export default "__VITE_ASSET__0b171af1__"